export const CONFIG_PIE = {
  appendPadding: 10,
  angleField: 'value',
  colorField: 'type',
  color: ['#ffed00', '#ededed', '#757575'],
  radius: 0.8,
  label: {
    type: 'outer',
    content: '{name} {percentage}'
  },
  interactions: [{ type: 'pie-legend-active' }, { type: 'element-active' }]
};

export const TIME_TYPE = {
  Year: 'Year',
  Month: 'Month',
  Week: 'Week'
};

export const TASK_COMPLETION = {
  Completed: 'completed',
  Interrupted: 'interrupted',
  Stopped: 'stopped'
};

export const STATE_PROP = 'cleaningTaskCompletion';
